
// 列表项类型
type listObject = {
  stockCode: string;
  stockName: string;
};
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import CommonTargetChart from '@/components/common/CommonTargetChart.vue';
import CommonRankName from '@/components/common/CommonRankName.vue';
import CommonRankNumber from '@/components/common/CommonRankNumber.vue';
import CommonLoading from '@/components/common/CommonLoading.vue';
import { pushBy2804, getDomTop } from '@/utils/tools';
import GuideCard from './GuideCard.vue';
import { getHomeRaiseSpace, getHomeSingleRaiseSpace } from '@/apis/index';
import { AJAX_STATUS } from '@/config/config';
@Component({
  components: {
    CommonTargetChart,
    CommonRankName,
    CommonRankNumber,
    GuideCard,
    CommonLoading,
  },
})
export default class SingleRaise extends Vue {
  // 用户选择的周期
  @Prop() private selectedDate!: string;
  @Prop() private maxLength!: number;
  @Prop() private num!: string;
  @Prop() private upspaceBannerImg!: string;
  // 列表项
  list: listObject[] = [];
  // 展示图表的列表项 上涨空间
  singleRaiseSpace = '--.--%';
  // 展示图表的列表项 均价
  singleAvgPrice: number | string = 0;
  // 展示图表的列表项 在列表中的索引
  showChartIndex = -1;
  // 接口请求状态
  ajaxStatus = AJAX_STATUS.loading;
  isLoading = false;
  isHandleScroll = false;
  isInitCardJump = false;
  // 获取展示图表的列表项信息的query信息
  get queryInfo() {
    return {
      type: this.selectedDate,
      stock_code: this.list[this.showChartIndex]?.stockCode,
    };
  }
  get duration() {
    // 配置显示图表周期
    const durationObj = {
      a1m: '近一个月',
      a3m: '近三个月',
      a6m: '近六个月',
    };
    // 通过选中的筛选周期进行匹配获取
    return durationObj[`a${this.selectedDate}`];
  }
  // 选择的周期变化请求接口
  @Watch('selectedDate')
  onSelectedDateChanged() {
    this.getData(true);
  }
  // 列表项展示图表项索引变化时 更新数据
  @Watch('showChartIndex')
  onShowChartIndexChanged() {
    if (this.showChartIndex !== -1) {
      // 展示图表的列表项 上涨空间
      this.singleRaiseSpace = '--.--%';
      // 展示图表的列表项 均价
      this.singleAvgPrice = 0;
      // 获取单个股票信息
      this.getSingleData();
    }
  }
  // 列表项展示图表项索引变化时 更新数据
  @Watch('num')
  onNumChanged() {
    this.getData(true);
  }
  toSingle(info: any) {
    // 跳转路由 个股主页
    pushBy2804('/stockPage', {
      stockcode: info.stockCode,
      stockname: info.stockName,
      name: info.stockName,
      marketid: info.market,
    });
  }
  reloadData() {
    this.getData(true);
  }
  handleShowChart(index: number) {
    if (this.showChartIndex === index) {
      // 当前索引图表展示状态的话就关闭
      this.showChartIndex = -1;
      return;
    }
    // 当前索引图表没展示的话就关闭 并打开对应的索引
    this.showChartIndex = index;
  }
  handleData(flag: boolean, list: Array<any>) {
    // flag true 重新加载 false 滚动加载
    if (flag) {
      this.list = list;
    } else {
      this.list = this.list.concat(list);
      this.$nextTick(() => {
        !this.maxLength && !this.isHandleScroll && this.handleScroll();
      });
    }
    // 加载结果
    const { nomore, nodata, end } = AJAX_STATUS;
    if (!list.length) {
      this.ajaxStatus = this.list.length ? nomore : nodata;
    } else {
      this.ajaxStatus = list.length < 15 ? nomore : end;
    }
    !this.isInitCardJump && this.handleCardJump();
    this.isLoading = false;
  }
  getData(flag: boolean = false) {
    const { nomore, end, loading } = AJAX_STATUS;
    if (flag) {
      this.list = [];
    } else {
      if (this.isLoading || this.ajaxStatus === nomore) {
        return;
      }
    }
    this.isLoading = true;
    this.ajaxStatus = loading;
    // 获取排行榜信息 只取前5
    getHomeRaiseSpace({
      type: this.selectedDate || '1m',
      start: flag ? 0 : this.list.length,
      more_than: this.num,
      limit: this.maxLength || 15,
    })
      .then(res => {
        if (res.statusCode === 0) {
          const list = res.data.list.slice(0, this.maxLength || 15);
          this.handleData(flag, list);
          // 列表数据更新的时候需要更新第一项展示的信息
          res.data.list.length && this.getSingleData();
        } else {
          this.ajaxStatus = end;
        }
      })
      .catch(() => {
        this.ajaxStatus = end;
      });
  }
  handleScroll() {
    const dom = window.$('.rank-single-list')[0] as HTMLElement;
    const list = this.$refs.singleraise as HTMLElement;
    this.isHandleScroll = true;
    dom.addEventListener('scroll', () => {
      const listHeight = list.scrollHeight;
      if (dom.scrollTop + dom.clientHeight >= listHeight - 3) {
        this.getData(false);
      }
    });
  }
  handleCardJump() {
    // 获取从卡片过来的股票代码
    if (window.getParam('jumpTab') === 'raise') {
      this.isInitCardJump = true;
      const stockCode = window.getParam('stockcode');
      // 滚动定位到指定位置
      setTimeout(() => {
        // 获取模块dom
        let dom = document.getElementById('single-rank');
        if (stockCode && this.list.length) {
          // 有数据并且判定为从卡片过来的
          const index = this.list.findIndex(item => `${item.stockCode}` === stockCode);
          if (index > -1) {
            // 将DOM滚动到顶部并且设置index展示图表
            dom = this.$refs[`raise${index}`][0] as HTMLElement;
            this.showChartIndex = index;
          }
        }
        window.scrollTo({
          left: 0,
          top: getDomTop(dom),
          behavior: 'smooth',
        });
      }, 300);
    }
  }
  getSingleData() {
    if (!this.queryInfo?.stock_code) {
      // 没有股票代码不让查
      return;
    }
    getHomeSingleRaiseSpace(this.queryInfo).then(res => {
      // 获取个股的数据
      const { risingSpace, avgPrice } = res.data;
      // 更新数据
      this.singleRaiseSpace = `${risingSpace > 0 ? '+' : ''}${(risingSpace * 100).toFixed(2)}%`;
      // 最新目标价
      this.singleAvgPrice = avgPrice ? (avgPrice / 100).toFixed(2) : '--';
    });
  }
  created() {
    // 排行榜默认展示第一项 首页默认不展示
    this.showChartIndex = this.$route.name === 'rank' ? 0 : -1;
  }
  mounted() {
    // 获取数据
    this.getData();
  }
}
